import { FileRejection, FileError, FileWithPath } from 'react-dropzone';
import { format, R } from '@/features/booking/resources/Texts.resx';
import { ErrorCode } from '@/features/booking/widgets/describe-problem/model/useAttachments';

type FileRejectionsProps = {
    fileRejections: readonly FileRejection[];
};

const getFileUploadErrorMessage = (e: FileError, file: FileWithPath) => {
    return e.code === ErrorCode.FileTooLarge
        ? `${format(R.FileTooLargeErrorMessage, file.name)}`
        : e.message;
};

export const FileRejections = ({ fileRejections }: FileRejectionsProps) => {
    if (!fileRejections?.length) return null;

    return (
        <div className="mt-4 flex flex-col gap-2 rounded-xl border border-gray-300 bg-gray-100 p-4 text-sm">
            <div className="text-action-red text-lg font-bold">
                {R.FileRejectionsHeader}
            </div>

            {fileRejections.map(({ file, errors }) => {
                return (
                    <div key={file.path} className="flex flex-row gap-4">
                        <span className="line-clamp-2 max-w-1/3 font-bold text-ellipsis">
                            {file.name}
                        </span>

                        <div>
                            {errors.map((e) => {
                                return (
                                    <span key={e.code}>
                                        {getFileUploadErrorMessage(e, file)}
                                    </span>
                                );
                            })}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
